var map = {
	"./delete.svg": "26a0",
	"./libra-ic.png": "249b",
	"./libra/icon-libra.png": "b332",
	"./libra/icon-libra.svg": "7656",
	"./libra/icon-libra2.svg": "b503",
	"./libra/icon-libra@2x.png": "4a95",
	"./libra/icon-libra@3x.png": "d27f",
	"./logo.png": "4ffd",
	"./logo/logo.png": "21dd",
	"./menu/breakfast/set1.png": "7549",
	"./menu/breakfast/set2.png": "54a3",
	"./menu/breakfast/set3.png": "388a",
	"./menu/breakfast/set4.jpg": "4c43",
	"./menu/breakfast/set5.png": "93a7",
	"./menu/classcafe/Cha-Thai.png": "dca9",
	"./menu/classcafe/IcedCaramelMachiato.png": "3882",
	"./menu/classcafe/IcedCocoa.png": "b7f0",
	"./menu/classcafe/IcedEspresso.png": "9d38",
	"./menu/coffee/cappuccino.jpg": "3328",
	"./menu/coffee/caramel_frappe.jpg": "d50d",
	"./menu/coffee/choco_frappe.jpg": "9dd5",
	"./menu/coffee/espresso.jpg": "1e56",
	"./menu/coffee/kick_frappe.jpg": "8ac7",
	"./menu/fastfood/1.jpg": "89ba",
	"./menu/fastfood/2.jpg": "b75f",
	"./menu/fastfood/3.jpg": "b5f9",
	"./menu/fastfood/4.jpg": "a58b",
	"./menu/folkrice/black.jpg": "d9f2",
	"./menu/folkrice/brown.jpg": "fe82",
	"./menu/folkrice/red.jpg": "c886",
	"./menu/folkrice/white.jpg": "6411",
	"./menu/snack/chocolate.png": "9a6e",
	"./menu/snack/corn-snack.png": "3e04",
	"./menu/snack/french-fries.png": "f1a7",
	"./menu/snack/oreo.png": "2367",
	"./menu/snack/potato-chips.png": "5e3b",
	"./menu/specialdrink/1.jpg": "943e",
	"./menu/specialdrink/2.jpg": "665b",
	"./menu/specialdrink/3.jpg": "51f8",
	"./menu/specialdrink/4.jpg": "e723",
	"./menu/specialdrink/5.jpg": "5355",
	"./qr-scaner-border.png": "29d5",
	"./sidebar-item/breakfast.svg": "2626",
	"./sidebar-item/coffee.svg": "d69c",
	"./sidebar-item/munchies.svg": "77b8",
	"./sidebar-item/sandwiches.svg": "fb72",
	"./sidebar-item/special-drinks.svg": "3646"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";